export default function CommentIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
    >
      <path
        d="M2.32829 14.8774L2.44648 14.9181L2.32828 14.8774L2.32444 14.8886C2.29464 14.9749 2.26419 15.0595 2.23323 15.1423C2.18449 15.2725 2.13451 15.3981 2.08387 15.5177C1.9703 15.786 2.18728 16.101 2.49192 16.0511C2.63361 16.0279 2.77174 16.0039 2.90634 15.9793C3.00229 15.9617 3.09646 15.9438 3.18884 15.9256L3.2092 15.9215C5.00177 15.5662 6.12019 15.0989 6.66659 14.8269C7.40587 15.0208 8.18919 15.125 9 15.125C13.4711 15.125 17.125 11.9502 17.125 8C17.125 4.04981 13.4711 0.875 9 0.875C4.52889 0.875 0.875 4.04981 0.875 8C0.875 9.77735 1.61689 11.4006 2.83957 12.6462C2.76252 13.3888 2.56734 14.183 2.32829 14.8774ZM4.08966 12.7073C4.12161 12.3736 4.00309 12.0431 3.7664 11.8057C2.72661 10.763 2.125 9.43153 2.125 8C2.125 4.89107 5.058 2.125 9 2.125C12.942 2.125 15.875 4.89107 15.875 8C15.875 11.1089 12.942 13.875 9 13.875C8.2817 13.875 7.59149 13.7808 6.9442 13.6073C6.67644 13.5355 6.3916 13.5651 6.14431 13.6904C5.7852 13.8724 5.00787 14.2155 3.74518 14.5236C3.90697 13.9343 4.03191 13.3106 4.08966 12.7073Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
